import React from 'react';
import { Square } from '@grubhubprod/gh-cookbook-react';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';
import { DataTableLoading } from 'src/components/DataTable/components/DataTableLoading/DataTableLoading';
import { DataTableEmpty } from 'src/components/DataTable/components/DataTableEmpty/DataTableEmpty';
import {
  DataTableNoResults,
  DataTableNoResultsProps,
} from 'src/components/DataTable/components/DataTableNoResults/DataTableNoResults';
import {
  DataTableError,
  DataTableErrorProps,
} from 'src/components/DataTable/components/DataTableError/DataTableError';

export type DataTableBodyProps<T> = {
  children: (item: T) => React.ReactNode;
  emptyComponent?: React.ReactNode;
  noResultsComponent?: DataTableNoResultsProps['children'];
  errorComponent?: DataTableErrorProps['children'];
};

export const DataTableBody = <T,>({
  children,
  emptyComponent,
  noResultsComponent,
  errorComponent,
}: DataTableBodyProps<T>): JSX.Element => {
  const { data, isLoading, isEmpty, isError } = useDataTableContext();
  const showData = !isEmpty && !isError;

  return (
    <Square
      position="relative"
      bg="untintedBackground"
      marginTop={isEmpty ? '0' : '-1px'}
      opacity={isLoading && showData ? 0.5 : 1}
      minHeight={isEmpty || isError ? '100px' : 'auto'}
    >
      <DataTableLoading />
      {showData && data.map(children)}
      <DataTableEmpty>{emptyComponent}</DataTableEmpty>
      <DataTableNoResults>{noResultsComponent}</DataTableNoResults>
      <DataTableError>{errorComponent}</DataTableError>
    </Square>
  );
};
